import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  OnInit,
  HostListener,
} from '@angular/core';
interface pieStyle {
  [propName: string]: any;
}
@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.less'],
})
export class PieChartComponent implements OnInit {
  @Input() chartData: { label: string; value: number; color: string }[] = [];
  @Input() totalClaim: number = 0;
  hasReady: boolean = false;
  pieStyle: pieStyle = {};
  @ViewChild('piechart') pieChartContainer: ElementRef | undefined;
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculatePieStyles();
    }, 1000);
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    // 当窗口大小改变时调用的方法
    this.calculatePieStyles();
  }
  execPoint(cx: number, cy: number, r: number, ratio: number) {
    const rad = ratio * 2 * Math.PI;
    return {
      x: cx + Math.sin(rad) * r,
      y: cy - Math.cos(rad) * r,
    };
  }
  calculatePieStyles() {
    if (this.totalClaim === 0) return;
    const containerWidth = this.pieChartContainer?.nativeElement.offsetWidth;
    const containerHeight = this.pieChartContainer?.nativeElement.offsetHeight;
    // 圆心坐标
    const cx = containerWidth / 2;
    const cy = containerHeight / 2;

    // 半径
    const r = Math.min(containerWidth, containerHeight) / 2;

    // 偏转量
    let offset = 0;

    this.chartData.forEach((item) => {
      const ratio = item.value / this.totalClaim;
      let path = `M ${cx},${cy}`;
      // 圆弧起点
      const start = this.execPoint(cx, cy, r, offset);
      path += ` L ${start.x},${start.y}`;
      // 圆弧终点
      offset += ratio;
      const end = this.execPoint(cx, cy, r, offset);
      const angle = ratio * 2 * Math.PI;
      path += ` A ${r},${r} 0,${angle > Math.PI ? 1 : 0},1 ${end.x},${end.y}`;
      path += ' Z';
      this.pieStyle[item.label] = {
        clipPath: `path('${path}')`,
        backgroundColor: item.color,
      };
      this.hasReady = true;
    });
  }
  ngOnInit(): void {
    this.totalClaim = this.chartData.reduce(
      (total, data) => total + data.value,
      0
    );
  }
}
